import Loadable from '../../components/loadable';

const WorkoutsList = Loadable({
  loader: () => import('../../pages/workouts/workouts_list'),
  type: 'block',
});

angular.module('gym').value('WorkoutsList', WorkoutsList);
